import gql from 'graphql-tag';

import {User} from './fragments';

export const SaveUserMutation = gql`
  mutation saveUser(
    $_id: String
    $active: Boolean
    $email: String!
    $password: String
    $phone: String!
    $firstName: String!
    $lastName: String!
    $projects: [String]
    $role: String!
  ) {
    saveUser(
      _id: $_id
      email: $email
      active: $active
      password: $password
      phone: $phone
      firstName: $firstName
      lastName: $lastName
      projects: $projects
      role: $role
    ) {
      ...User
    }
  }
  ${User}
`;

export const SaveUserMutationConfig = {
  props: ({mutate, ownProps: {match: {params: {id: _id}}}}) => ({
    save: user =>
      mutate({
        variables: {_id, ...user},
        updateQueries: {
          allUsers: ({allUsers, ...prev}, {mutationResult: {data: {saveUser}}}) =>
            _id
              ? {...prev, allUsers: allUsers.map(user => (user._id === _id ? saveUser : user))}
              : {...prev, allUsers: [saveUser, ...allUsers]},
        },
      }),
  }),
};

export const SaveProjectMutation = gql`
  mutation saveProject($_id: String, $key: String!, $name: String!) {
    saveProject(_id: $_id, key: $key, name: $name) {
      _id
      name
      key
    }
  }
`;

export const SaveProjectMutationConfig = {
  props: ({mutate, ownProps: {match: {params: {id: _id}}}}) => ({
    save: variables =>
      mutate({
        variables: {_id, ...variables},
        updateQueries: {
          allProjects: ({allProjects, ...prev}, {mutationResult: {data: {saveProject}}}) =>
            _id
              ? {...prev, allProjects: allProjects.map(Project => (Project._id === _id ? saveProject : Project))}
              : {...prev, allProjects: [saveProject, ...allProjects]},
        },
      }),
  }),
};

export const SaveContentMutation = gql`
  mutation saveContent(
    $_id: String
    $project: String!
    $type: String!
    $title: String!
    $slug: String!
    $teaser: String
    $content: JSON!
    $attachments: [String]
    $ogImage: String
    $seoTitle: String
    $seoDescription: String
    $linkToIndex: Boolean
    $position: Int
    $snippets: [String]
  ) {
    saveContent(
      _id: $_id
      project: $project
      type: $type
      title: $title
      slug: $slug
      teaser: $teaser
      content: $content
      attachments: $attachments
      ogImage: $ogImage
      seoTitle: $seoTitle
      seoDescription: $seoDescription
      linkToIndex: $linkToIndex
      position: $position
      snippets: $snippets
    ) {
      _id
      project
      type
      title
      slug
    }
  }
`;

export const SaveContentMutationConfig = {
  props: ({mutate, ownProps: {match: {params: {id: _id}}}}) => ({
    save: variables =>
      mutate({
        variables: {_id, ...variables},
        updateQueries: {
          allContents: ({allContents, ...prev}, {mutationResult: {data: {saveContent}}}) =>
            _id
              ? {...prev, allContents: allContents.map(content => (content._id === _id ? saveContent : content))}
              : {...prev, allContents: [saveContent, ...allContents]},
        },
      }),
  }),
};

export const DeleteContentMutation = gql`
  mutation deleteContent($_id: String) {
    deleteContent(_id: $_id)
  }
`;

export const DeleteContentMutationConfig = {
  props: ({mutate, ownProps: {match: {params: {id: _id}}}}) => ({
    delete: () =>
      mutate({
        variables: {_id},
      }),
  }),
};

export const SaveSnippetMutation = gql`
  mutation saveSnippet(
    $_id: String
    $project: String!
    $type: String!
    $title: String!
    $slug: String!
    $description: String
    $snippet: JSON!
  ) {
    saveSnippet(
      _id: $_id
      project: $project
      type: $type
      title: $title
      slug: $slug
      description: $description
      snippet: $snippet
    ) {
      _id
      project
      language
      type
      title
      slug
    }
  }
`;

export const SaveSnippetMutationConfig = {
  props: ({mutate, ownProps: {match: {params: {id: _id}}}}) => ({
    save: variables =>
      mutate({
        variables: {_id, ...variables},
        updateQueries: {
          allSnippets: ({allSnippets, ...prev}, {mutationResult: {data: {saveSnippet}}}) =>
            _id
              ? {...prev, allSnippets: allSnippets.map(snippet => (snippet._id === _id ? saveSnippet : snippet))}
              : {...prev, allContents: [saveSnippet, ...allSnippets]},
        },
      }),
  }),
};

export const SaveNavigationMutation = gql`
  mutation saveContent(
    $_id: String
    $project: String!
    $type: String!
    $title: String!
    $slug: String!
    $teaser: String
    $content: JSON!
    $attachments: [String]
    $ogImage: String
    $seoTitle: String
    $seoDescription: String
    $linkToIndex: Boolean
    $position: Int
    $snippets: [String]
  ) {
    saveContent(
      _id: $_id
      project: $project
      type: $type
      title: $title
      slug: $slug
      teaser: $teaser
      content: $content
      attachments: $attachments
      ogImage: $ogImage
      seoTitle: $seoTitle
      seoDescription: $seoDescription
      linkToIndex: $linkToIndex
      position: $position
      snippets: $snippets
    ) {
      _id
      project
      type
      title
      slug
    }
  }
`;

export const SaveNavigationMutationConfig = {
  props: ({mutate, ownProps: {match: {params: {id: _id}}}}) => ({
    save: variables =>
      mutate({
        variables: {_id, ...variables},
        updateQueries: {
          allNavigations: ({allNavigations, ...prev}, {mutationResult: {data: {saveNavigation}}}) =>
            _id
              ? {
                  ...prev,
                  allNavigations: allNavigations.map(
                    navigation => (navigation._id === _id ? saveNavigation : navigation)
                  ),
                }
              : {...prev, allNavigations: [saveNavigation, ...allNavigations]},
        },
      }),
  }),
};



// WEBPACK FOOTER //
// ./src/qql-shared/mutations.js